// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"679":"45fed583","6190":"315b7611"}[chunkId] + ".chunk.css";
};